import {isEmail, isExamplePhoneNumber, isPhoneNumber, isUrl, url_pattern, us_phone_number} from '../actions/static'
import { ExternalLinkIcon } from '../icons/Icons'

export const wrapTextAddLinks = (text, externalLinkIconAriaLabel, isEmpower, isLoadingIframeData = false) => {
  text = text.replace(/[\r\n]+/g, '\n') //remove extra line breaks
  if(!isEmpower) text = findPhoneLink(text, isLoadingIframeData)
  if (isLoadingIframeData) text = text.replace(/tabindex="0"/gm, 'tabindex="-1"')
  text = findUrlLink(text, externalLinkIconAriaLabel)
  return text
}

const withHttp = link => {
  if (!/[a-zA-Z0-9]/.test(link.slice(-1))) link = link.slice(0, -1)
  const url = !/^https?:\/\//i.test(link) ? `http://${link}` : link
  return ' ' + url.trim() + ' '
}

const findPhoneLink = (text, isLoadingIframeData) => {
  if (isExamplePhoneNumber(text) || !isPhoneNumber(text)) {
    return text
  }

  return text.replace(
    us_phone_number,
    url => `<a class="link" tabindex=${isLoadingIframeData ? -1 : 0} href="tel:${url}">${url}</a>`,
  )
}
const findUrlLink = (text, externalLinkIconAriaLabel) => {
  const textArr = text.split(' ')
  textArr.forEach((word, index) => {
    if (!isEmail(word) && isUrl(word) && !word.includes('data-href')) {
      word = word.replace(
        url_pattern,
        url =>
          `<span class="linkCreated">${url}${ExternalLinkIcon(externalLinkIconAriaLabel)}</span>`
      )
      textArr[index] = word
    }
  })
  return textArr.join(' ')
}
